import React from 'react';
import { formatDate } from 'services/utils';
import { showClasses } from 'services/constants';

export default function DogAddToShows(props) {

  const idPrefix = props.idPrefix || 'dogToShow';

  function getShowData(showId) {
    const res = (props.shows || []).find(show => show.show_id === showId) || {
      show_id: showId,
      class_in_show: '',
    };
    return {...res};
  }

  function renderShowRegistrationForm(show, i) {
    let registerTo = props.registerTo.find(regData => +regData.show_id === show.id);
    
    if (!registerTo) {
      registerTo = getShowData(show.id)
      props.registerTo.push(registerTo);
    }
    for (let attr in registerTo) {
      if (!registerTo[attr]) registerTo[attr] = '';
    }
    
    function propertyChanged({target}) {
      const fieldName = target.name;
      registerTo[fieldName] = target.value;
      if (props.onChange) props.onChange();
    }

    return (
      <div className="row mt-4" key={'regShow' + i}>
        <div className="col-12">
          <h5><strong>{show.name}</strong> - {formatDate(show.starts_at)}</h5>
        </div>
        <div className="col-sm-12 mb-3">
          <label htmlFor={idPrefix+'_'+show.id+"_class_in_show"}>Класс</label>
          <select id={idPrefix+'_'+show.id+"_class_in_show"} name="class_in_show" className="form-select" 
            value={registerTo.class_in_show} onChange={propertyChanged} >
            {showClasses.map(showClass => <option key={showClass.id || '0'} value={showClass.id}>{showClass.name}</option>)}
          </select>
        </div>
      </div>
    )
  }

  if (!props.openShows) return null;
  
  return (
    <div className="mt-4">
      <h4>Зарегистрировать на выставки:</h4>
      {props.openShows.length ? props.openShows.map(renderShowRegistrationForm) : <p>Нет выставок, открытых для регистрации.</p>}
    </div>
  );

}